import type {
  SocialSalesSourceCreateInput,
  SocialSalesSourceDTO,
  SocialSalesSourceUpdateInput,
} from "@/modules/social-sales-sources/domain/contracts";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type {
  SocialSalesSourceDTO,
  SocialSalesSourceCreateInput,
  SocialSalesSourceUpdateInput,
} from "@/modules/social-sales-sources/domain/contracts";

export const socialSalesSourcesApi = {
  async list(activeOnly?: boolean): Promise<SocialSalesSourceDTO[]> {
    const q = activeOnly ? "?activeOnly=true" : "";
    return fetcher.get<SocialSalesSourceDTO[]>(
      `${config.apiUrl}/social-sales-sources${q}`,
    );
  },

  async get(id: string): Promise<SocialSalesSourceDTO> {
    return fetcher.get(`${config.apiUrl}/social-sales-sources/${id}`);
  },

  async create(
    body: SocialSalesSourceCreateInput,
  ): Promise<SocialSalesSourceDTO> {
    return fetcher.post(`${config.apiUrl}/social-sales-sources`, body);
  },

  async patch(
    id: string,
    body: SocialSalesSourceUpdateInput,
  ): Promise<SocialSalesSourceDTO> {
    return fetcher.patch(`${config.apiUrl}/social-sales-sources/${id}`, body);
  },
};
